import { useSignedMedia } from "@/lib/hooks/use-signed-media";
import { ResearchBadge } from "./research-badge";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import { getInitials } from "@/lib/utils";
import { buildRedactedPseudoId } from "@/lib/redacted-display";

interface UserNameColumnProps {
  profilePhoto: string | null;
  name: string | null;
  researchConsent: boolean;
  redactedFields?: string[];
  userId?: string;
}

export const UserNameColumn = ({
  profilePhoto,
  name,
  researchConsent,
  redactedFields,
  userId,
}: UserNameColumnProps) => {
  const nameRedacted = redactedFields?.includes("name") ?? false;
  const photoRedacted = redactedFields?.includes("profile_picture_url") ?? false;

  const profilePhotoSigned = useSignedMedia(photoRedacted ? "" : (profilePhoto ?? ""));
  const displayName = nameRedacted ? buildRedactedPseudoId(userId) : (name ?? "");

  return (
    <div className="flex items-center gap-2">
      <Avatar className="h-8 w-8">
        {!photoRedacted && (
          <AvatarImage src={profilePhotoSigned.url} alt={displayName} />
        )}
        <AvatarFallback className="text-xs">
          {nameRedacted ? "?" : getInitials(name ?? "")}
        </AvatarFallback>
      </Avatar>
      <div className="flex items-center gap-1">
        <div className="font-bold">{displayName}</div>
        <ResearchBadge isResearchParticipant={researchConsent} />
      </div>
    </div>
  );
};
